<template>
  <rect id="Сгруппировать 5250" width="16.023003" height="20.000000" fill-opacity="0" />
  <mask
    id="mask1_8"
    maskUnits="userSpaceOnUse"
    x="0.000001"
    y="0.000000"
    width="16.023003"
    height="20.000000">
    <g>
      <rect id="Прямоугольник 208" x="0.000001" width="16.023001" height="20.000000" />
    </g>
  </mask>
  <g>
    <g>
      <path id="Контур 806" d="M8 20C9.11 20 10 19.1 10 18L6 18C6 19.1 6.9 20 8 20Z" fill-rule="nonzero" />
    </g>
  </g>
  <g>
    <g>
      <path
        id="Контур 807"
        d="M9 2.07L9 0.98C9 0.43 8.56 0 8.02 0C7.48 0 7.04 0.43 7.04 0.98L7.04 2.07C3.63 2.54 1 5.46 1 9L1 13.58L0.77 13.81C-0.18 14.73 -0.05 15.52 0.1 15.91C0.23 16.22 0.66 16.94 2.01 16.95L14 16.95C15.34 16.95 15.78 16.22 15.91 15.91C16.07 15.53 16.19 14.73 15.24 13.81L15 13.57L15 9C15 5.47 12.39 2.56 9 2.07Z"
        fill-rule="nonzero" />
    </g>
  </g>
</template>